import { Autocomplete, Grid, MenuItem, Stack, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { format, parseISO } from "date-fns";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import eurLogo from "../../../../assets/images/logo/sanEurLogoJpeg.jpeg";
import intlLogo from "../../../../assets/images/logo/sanIntlLogoJpeg.jpeg";
import antLogo from "../../../../assets/images/logo/agronixLogoJpeg.jpeg";
import { companies, portsOfDischarge, titles } from "../../../../utils/menu-items";
import { retrieveFilteredAddressesApi } from "../../../../components/api/AddressApiService";

const convertImageToBase64 = (url, callback) => {
  const xhr = new XMLHttpRequest();
  xhr.onload = function () {
    const reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.send();
};

const createExcelWithLogoAndData = async (offerDetails) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("My Sheet");
  const len = offerDetails?.items.length;

    const determineRemark = (incoterm, portOfLoading, portOfDischarge) => {
    const incotermsUsingPortOfLoading = ["EXW", "FCA", "FAS", "FOB"];
    const incotermsUsingPortOfDischarge = ["CFR", "C&F", "CIF", "CPT", "CIP", "DAP", "DPU", "DDP"];
  
    const safeIncoterm = incoterm || "";
  
    if (incotermsUsingPortOfLoading.includes(safeIncoterm)) {
      return `${safeIncoterm} ${portOfLoading || ""}`;
    } else if (incotermsUsingPortOfDischarge.includes(safeIncoterm)) {
      return `${safeIncoterm} ${portOfDischarge || ""}`;
    }
    return ""; 
  };

worksheet.pageSetup.printArea = `A1:K${58+len}`;

  worksheet.pageSetup.fitToPage = true;
  worksheet.pageSetup.fitToWidth = 1;
  worksheet.pageSetup.fitToHeight = 1;

  const sellingCompany =
  offerDetails?.sellingCompany === "SGE" ? "SGE" : "ANT" ? "ANT" :"SGI";

  const sellingCompanyHeader =
  offerDetails?.sellingCompany === "SGE"
    ? "SanGroup Europe Kft."
    : offerDetails?.sellingCompany === "ANT"
    ? "AGRONIX TRADING PTE. LTD."
    : "SANGROUP INTERNATIONAL PTE.LTD.";
const sellingAddressOne =
offerDetails?.sellingCompany === "SGE"
    ? "Stefania ut 101-103"
    : "Head Office : 11 Irving Place, # 09-02 Tai Seng Point Singapore 369551";
const sellingAddressTwo =
offerDetails?.sellingCompany === "SGE"
    ? "H-1143 Budapest, Hungary"
    : offerDetails?.sellingCompany === "ANT"
    ? "Company Registration / Tax No : 202504646R "
    : "Company Registration / Tax No : 201717395N ";
const sellingAddressThree =
offerDetails?.sellingCompany === "SGE"
    ? "Registration no: 01-09-400244 VAT no: Hu27842588-2-42"
    : "sgi.info@sangroupintl.com";

  var logo;
  // Convert and add the intlLogo
  if (offerDetails.sellingCompany === "SGI") {
    logo = intlLogo;
  } else if (offerDetails.sellingCompany === "SGE") {
    logo = eurLogo;
  } else if (offerDetails.sellingCompany === "ANT") {
    logo = antLogo;
  }else {
    logo = intlLogo;
  }
  convertImageToBase64(logo, async (base64Image) => {
    const imageId = workbook.addImage({
      base64: base64Image,
      extension: "jpeg",
    });

    if (offerDetails.sellingCompany === "SGI") {
      worksheet.addImage(imageId, "A1:D5");
    } else if (offerDetails.sellingCompany === "SGE") {
      worksheet.addImage(imageId, "A1:D5");
    } else if (offerDetails.sellingCompany === "ANT") {
      worksheet.addImage(imageId, "A1:D5");
    }else {
      worksheet.addImage(imageId, "A1:D5");
    }

    const startRow = 6;
    const headerRowNumber = startRow + 11;

    const headerFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF4F81BD" }, 
    };

    const dataForExcel = [
      [],
      [offerDetails?.companyName,,,,,,,,,,format(new Date(), 'dd MMM yyyy')],
      [offerDetails?.companyAddressOne],
      [offerDetails?.companyAddressTwo],
      ["Attn To: "+" "+ offerDetails?.contactPerson +","],
      [],
      ["Subject: "+" "+(offerDetails?.subject||"")],
      [],
      ["We are pleased to offer you the following tobaccos."],
      [],
      [],
      [
        "Origin",
        "Crop Year",
        "Type",
        "Grade",
        "Leaf Form",
        "Packaging",
        "Volume KG",
        "Nicotine %",
        "Sugar %",
        "Price " + offerDetails?.incoterm,
        "Remark",
      ],
      ...offerDetails?.items.map((item) => [
        item?.origin,
        item?.crop,
        item?.type,
        item?.salesGrade,
        item?.leafForm,
        item?.packaging,
        item?.volume ? new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2 }).format(item?.volume): '',
        item?.nicotine ? new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2 }).format(item?.nicotine): '',
        item?.sugar ? new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2 }).format(item?.sugar): '',
       `${item?.finalOfferPriceCurrency === 'USD' ? '$' : item?.finalOfferPriceCurrency === 'EUR' ? '€' : ''}`.padEnd(5, ' ') +
    `${item?.price ? new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2 }).format(item.price):''}`.padStart(10, ' '),
      determineRemark(item?.incoterm, item?.portOfLoading, item?.portOfDischarge),
      ]),
      [],
      ["Terms and Conditions:"],
      [],
      [
        (() => {
          // Collect unique currencies from items
          const currencies = Array.from(new Set((offerDetails?.items || []).map(i => i.finalOfferPriceCurrency).filter(Boolean)));
          // Collect unique incoterms from items
          const incoterms = Array.from(new Set((offerDetails?.items || []).map(i => i.incoterm).filter(Boolean)));
          const currencyStr = currencies.length > 1 ? currencies.join(' and ') : (currencies[0] || '');
          const incotermStr = incoterms.length > 1 ? incoterms.join(' and ') : (incoterms[0] || '');
          return `* Offer price is in: ${currencyStr} per kg at ${incotermStr}`;
        })()
      ],
      ["* Value Date: " + offerDetails?.valueDate],
      ["* Shipment: " + offerDetails?.shipment],
      ["* Payment term: " + offerDetails?.paymentTerm],
      ["* Finance Charge: " + offerDetails?.financeCharge],
      ["* Storage Charge: " + offerDetails?.storageCharge],
      ["* Packing: " + offerDetails?.packaging],
      ["* " + offerDetails?.comment],
      ["* " + offerDetails?.commentOne],
      ["* " + offerDetails?.commentTwo],
      [],
      [],
      [],
      [
        "Thank you for your continues support and cooperation with us. Look forward to hearing from you soon.",
      ],
      ["Birgul Sandal"],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [
        "",
        "",
        (sellingCompany ==='SGI' || sellingCompany ==='ANT') ? ("                                                             " +sellingAddressOne) : "",
        sellingCompany ==='SGE' ? ("                                                                        "+sellingAddressOne):null,
      ],
      ["", "", "                                                                    "+((sellingCompany ==='SGI' || sellingCompany ==='ANT') ? sellingAddressTwo : ""),
      sellingCompany ==='SGE' ? ("                                                                  "+sellingAddressTwo):null,],
      ["","", ((sellingCompany ==='SGI' || sellingCompany ==='ANT') ? ("                                                                                                 "+sellingAddressThree) : ""),sellingCompany ==='SGE' ? ("                                             "+sellingAddressThree):null,
      ],
    ];

    // Example: Inserting a row of data
    dataForExcel.forEach((row, index) => {
      const rowIndex = startRow + index;
      const excelRow = worksheet.getRow(rowIndex);
      row.forEach((cell, cellIndex) => {
        const cellAddress = excelRow.getCell(cellIndex + 1);
        cellAddress.value = cell;

        if (rowIndex === headerRowNumber) {
          // Apply header styles
          cellAddress.fill = headerFill;
          cellAddress.font = { bold: true, color: { argb: "FFFFFFFF" } };
          cellAddress.alignment = {
            wrapText: "true",
            vertical: "middle",
            horizontal: "center",
          };
          cellAddress.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          if (cellIndex === 1) {
          worksheet.getColumn(cellIndex+1).width = 7;
          worksheet.getColumn(cellIndex+2).width = 10;
          worksheet.getColumn(cellIndex+3).width = 15;
          worksheet.getColumn(cellIndex+4).width = 15;
          worksheet.getColumn(cellIndex+5).width = 12;
          worksheet.getColumn(cellIndex+6).width = 12;
          worksheet.getColumn(cellIndex+7).width = 8;
          worksheet.getColumn(cellIndex+8).width = 7;
          worksheet.getColumn(cellIndex+9).width = 12;
          worksheet.getColumn(cellIndex+10).width = 15;
          }
        } else if (rowIndex === 7) {
          cellAddress.font = { bold: true };
        } else if (rowIndex === 12) {
          cellAddress.font = { bold: true };
        } else if (rowIndex === 19 + len) {
          cellAddress.font = { bold: true, underline: true, size: "9" };
        } else if (rowIndex > 17 && rowIndex <= 17 + len) {
          cellAddress.border = {
            top: { style: "thin", color: "black" },
            left: { style: "thin", color: "black" },
            bottom: { style: "thin", color: "black" },
            right: { style: "thin", color: "black" },
          };
          cellAddress.alignment = {
            vertical: "middle",
            wrapText: "true",
            horizontal:"center",
          };
        } else if (rowIndex === 32 + len) {
          cellAddress.font = { size: "12" };
          cellAddress.alignment = { vertical: "middle" };
        } else if (rowIndex > 21 && rowIndex <= 30 + len) {
          cellAddress.font = { size: "9" };
        } else if (
          rowIndex === 56 + len ||
          rowIndex === 57 + len ||
          rowIndex === 58 + len
        ) {
          cellAddress.font = { color: { argb: "a0a3a2" }, size:"9" };
          cellAddress.alignment = { vertical: "middle" };
        }
      });
      excelRow.commit();
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "OfferWithLogo.xlsx");
  });
};


const CreateOfferPdf = (props) => {
  const { setPdfPopup, pdfPopup } = props;
  const[filteredAddresses, setFilteredAddresses] = useState([]);
  const[selectedAddress, setSelectedAddress] = useState(null);
  const [selectedContactPerson, setSelectedContactPerson] = useState(
  pdfPopup?.data[0]?.stakeholder?.contactPersons?.[0] || null
);

  const [items, setItems] = useState(
    pdfPopup && pdfPopup.data
      ? pdfPopup.data.map((offer) => ({
          id: offer?.item?.id || "",
          origin: offer?.salesOrigin || "",
          crop: offer?.salesCrop || "",
          type: offer?.item?.type || "",
          buyingGrade: offer?.item?.buyingGrade || "",
          salesGrade: offer?.salesGrade || "",
          leafForm: offer?.item?.leafForm || "",
          nicotine: offer?.salesNicotine || "",
          sugar: offer?.salesSugar || "",
          volume: offer?.volume || "",
          packaging: offer?.packaging
  ? offer.netWeightPerCase
    ? `${offer.packaging} / ${offer.netWeightPerCase}`
    : offer.packaging
  : offer.netWeightPerCase || "",
          price: offer?.finalOfferPrice || "",
          incoterm: offer?.incoterm || "",
          portOfLoading: offer?.portOfLoading || "",
          portOfDischarge: offer?.portOfDischarge || "",
          finalOfferPriceCurrency: offer?.finalOfferPriceCurrency || "",
        }))
      : [],
  );
  const [offerDetails, setOfferDetails] = useState({
    items: items,
    customerTitle: "",
    companyName: pdfPopup?.data[0]?.stakeholder?.name || "",
    contactPerson: pdfPopup?.data[0]?.stakeholder?.contactPersons?.find(p => p.isDefault)?.name
      || pdfPopup?.data[0]?.stakeholder?.contactPersons?.[0]?.name
      || pdfPopup?.data[0]?.stakeholder?.contactPerson
      || "",
    packaging: pdfPopup?.data[0]?.packaging || "",
    valueDate: pdfPopup?.data[0]?.validityDate ? new Date(pdfPopup?.data[0]?.validityDate).toLocaleDateString('en-GB') : "",
    paymentTerm: pdfPopup?.data[0]?.paymentTerm || "",
    remark: pdfPopup?.data[0]?.remark || "",
    incoterm: pdfPopup?.data[0]?.incoterm || "",
    portOfDischarge: pdfPopup?.data[0]?.portOfDischarge || "",
    sellingCompany: pdfPopup?.data[0]?.company || "",
    price: pdfPopup?.data[0]?.finalOfferPrice || "",
    finalOfferPriceCurrency: pdfPopup?.data[0]?.finalOfferPriceCurrency || "",
    companyAddressOne:"",
    companyAddressTwo:"",
    comment:pdfPopup?.data[0]?.comment || "",
    commentOne: pdfPopup?.data[0]?.commentOne || "",
    commentTwo: pdfPopup?.data[0]?.commentTwo || "",
    shipment: pdfPopup?.data[0]?.shipment || "",
    financeCharge: pdfPopup?.data[0]?.financeCharge || "",
    storageCharge: pdfPopup?.data[0]?.storageCharge || "",
});
const filterAddress = ({
  id: 0,
  stakeholderId: pdfPopup?.data[0]?.stakeholder?.id,
  stakeholderIdList: [pdfPopup?.data[0]?.stakeholder?.id],
  type: "",
  typeList: ["Pay To", "Bill To", "Ship To"],
  street: "",
  streetList: [],
  zipCode: "",
  zipCodeList: [],
  city: "",
  cityList: [],
  county: "",
  countyList: [],
  country: "",
  countryList: [],
  remark: "",
  recordStatusList: ["ACTIVE"],
});

function retrieveStakeholderAddresses(filterAddress) {
  retrieveFilteredAddressesApi(filterAddress)
    .then((response) => {
      setFilteredAddresses(response?.data);
    })
    .catch((error) => console.log(error.response?.data));
}

useEffect(() => {
  retrieveStakeholderAddresses(filterAddress)
}, []);

    return ( // Added return statement here
      <>
      <Stack direction="column">
        <Typography variant="body1" mb={2}>
          Selected Items
        </Typography>
        {pdfPopup &&
          pdfPopup.data &&
          pdfPopup.data.map((offer, index) => (
            <Grid container key={offer.id} spacing={2}>
              <Grid item xs={12} sm={1}>
                <Typography variant="body2"> Item ID </Typography>
                <TextField
                  disabled
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={offer?.item?.id || ""}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Typography variant="body2">Origin</Typography>
                <TextField
                  disabled
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={offer?.item?.origin || ""}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Typography variant="body2">Crop Year</Typography>
                <TextField
                  disabled
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={offer?.item?.crop || ""}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Typography variant="body2">Type</Typography>
                <TextField
                  disabled
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={offer?.item?.type || ""}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Typography variant="body2">Buying Grade</Typography>
                <TextField
                  disabled
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={offer?.item?.buyingGrade || ""}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Typography variant="body2">Sales Grade</Typography>
                <TextField
                  disabled
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={offer?.salesGrade || ""}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Typography variant="body2">Leaf Form</Typography>
                <TextField
                  disabled
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={offer?.item?.leafForm || ""}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Typography variant="body2">Sales Nicotine</Typography>
                <TextField
                  disabled
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={offer?.salesNicotine || ""}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Typography variant="body2">Sales Sugar</Typography>
                <TextField
                  disabled
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={offer?.salesSugar || ""}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
            <Typography variant="body2">Packaging</Typography>
            <TextField
              disabled
              variant="outlined"
              size="small"
              fullWidth
              value={offer?.packaging
                ? offer.netWeightPerCase
                  ? `${offer.packaging} / ${offer.netWeightPerCase}`
                  : offer.packaging
                : offer.netWeightPerCase || ""
              }
            />
          </Grid>
              <Grid item xs={12} sm={1}>
                <Typography variant="body2">Volume KG</Typography>
                <TextField
                  disabled
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={offer?.volume || ""}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Typography variant="body2">Price {offer?.incoterm}</Typography>
                <TextField
                  disabled
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={offer?.finalOfferPrice ? (offer?.finalOfferPrice + " " + (offer?.finalOfferPriceCurrency||"")) : ""}
                />
              </Grid>
            </Grid>
          ))}
        <Typography variant="body1" mb={2} marginTop={5}>
          Selected Offer Details
        </Typography>
        <Grid container spacing={2} marginBottom={5}>
                       <Grid item xs={12} sm={5.5}>
            <Typography variant="body2">Subject</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={offerDetails?.subject || ''}
              onChange={(e) => {
                setOfferDetails({
                  ...offerDetails,
                  subject: e.target.value,
                });
                if (e.target.value.length === 100) {
                  toast.error("Character limit (100) exceeded");
                }
              }}
              inputProps={{
                maxLength: 100,
              }}
            />
            </Grid>
             <Grid item xs={12} sm={6.5}></Grid>
          <Grid item xs={12} sm={1}>
            <Typography variant="body2">Selling Company</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              id="outlined-select-title"
              select
              value={offerDetails?.sellingCompany}
              onChange={(e) =>
                setOfferDetails({
                  ...offerDetails,
                  sellingCompany: e.target.value,
                })
              }
            >
              {companies.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={10}></Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Buying Company Name</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              disabled
              value={offerDetails?.companyName}
            />
          </Grid>
          <Grid item xs={12} sm={10}></Grid>
          <Grid item xs={12} sm={5.5}>
      <Typography variant="body2">Select Address Line 1</Typography>
      <Autocomplete
        options={filteredAddresses}
        getOptionLabel={(option) => {
          if (!option) return '';
          const type = option?.type || "";
          const street = option?.street || "";
          const city = option?.city || "";
      
          const addressPart1 = [street, city].filter(Boolean).join(", ");
          return `${type}: ${addressPart1}`;
        }}
        value={selectedAddress}
        onChange={(event, newValue) => {
          const newTerm = newValue ? newValue.value : "";
          setSelectedAddress(newValue);

    const street = newValue?.street || "";
    const city = newValue?.city || "";
    const county = newValue?.county || "";
    const zipCode = newValue?.zipCode || "";
    const country = newValue?.country || "";

    const companyAddressOne = [street, city].filter(Boolean).join(", ");
    const companyAddressTwo = [county, zipCode, country].filter(Boolean).join(", ");

    setOfferDetails((prevDetails) => ({
      ...prevDetails,
      companyAddressOne: companyAddressOne,
      companyAddressTwo: companyAddressTwo,
    }));
  }}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
            fullWidth
          />
        )}
        renderTags={() => null}
      />
    </Grid>
          <Grid item xs={12} sm={5.5}>
            <Typography variant="body2">
              Buying Company Address Line 2
            </Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              disabled
              value={(selectedAddress?.country||"") + "  " + (selectedAddress?.zipCode||"")}
            />
          </Grid>
          <Grid item xs={12} sm={1}></Grid>

          <Grid item xs={12} sm={5.5}>
            <Typography variant="body2">Address Line One</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={offerDetails?.companyAddressOne}
              onChange={(e) => {
                setOfferDetails({
                  ...offerDetails,
                  companyAddressOne: e.target.value,
                });
                if (e.target.value.length === 100) {
                  toast.error("Character limit (100) exceeded");
                }
              }}
              inputProps={{
                maxLength: 100,
              }}
            />
            {selectedAddress && (<Typography variant="body2" style={{ color: "red" }}>(Please use this field to make changes to the address as it will appear on the PDF. Note that your changes will not affect the actual address information.)</Typography>)}
          </Grid>
          <Grid item xs={12} sm={5.5}>
            <Typography variant="body2">Address Line Two</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={offerDetails?.companyAddressTwo}
              onChange={(e) => {
                setOfferDetails({
                  ...offerDetails,
                  companyAddressTwo: e.target.value,
                });
                if (e.target.value.length === 100) {
                  toast.error("Character limit (100) exceeded");
                }
              }}
              inputProps={{
                maxLength: 100,
              }}
            />
             {selectedAddress && (<Typography variant="body2" style={{ color: "red" }}>(Please use this field to make changes to the address as it will appear on the PDF. Note that your changes will not affect the actual address information.)</Typography>)}
          </Grid>

          <Grid item xs={12} sm={1}></Grid>

         <Grid item xs={12} sm={2}>
  <Typography variant="body2">Contact Person</Typography>
  <TextField
    variant="outlined"
    size="small"
    select
    fullWidth
    value={selectedContactPerson?.id || ""}
    onChange={(e) => {
      const selected = pdfPopup?.data[0]?.stakeholder?.contactPersons?.find(
        (person) => person.id === parseInt(e.target.value)
      );
      setSelectedContactPerson(selected);
      setOfferDetails({
        ...offerDetails,
        contactPerson: selected?.name || "",
      });
    }}
  >
    {(pdfPopup?.data[0]?.stakeholder?.contactPersons || []).map((person) => (
      <MenuItem key={person.id} value={person.id}>
        {person.name} – {person.position}
      </MenuItem>
    ))}
  </TextField>
</Grid>
          <Grid item xs={12} sm={10}></Grid>

          <Grid item xs={12} sm={1}>
            <Typography variant="body2">Value Date</Typography>
            <TextField
              disabled
              variant="outlined"
              size="small"
              fullWidth
              value={
                pdfPopup?.data[0]?.validityDate
                  ? format(
                      parseISO(pdfPopup?.data[0]?.validityDate),
                      "yyyy-MM-dd",
                    )
                  : ""
              }
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Payment Term</Typography>
            <TextField
              disabled
              variant="outlined"
              size="small"
              fullWidth
              value={pdfPopup?.data[0]?.paymentTerm}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="body2">Remark</Typography>
            <TextField
              disabled
              variant="outlined"
              size="small"
              fullWidth
              value={pdfPopup?.data[0]?.remark}
            />
          </Grid>
          <Grid item xs={12} sm={5.5}>
            <Typography variant="body2">Shipment</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={offerDetails?.shipment}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={5.5}>
            <Typography variant="body2">Finance Charge</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={offerDetails?.financeCharge}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={5.5}>
            <Typography variant="body2">Storage Charge</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={offerDetails?.storageCharge}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={5.5}>
            <Typography variant="body2">Comment</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={offerDetails?.comment}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={5.5}>
            <Typography variant="body2">Comment One</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={offerDetails?.commentOne}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={5.5}>
            <Typography variant="body2">Comment Two</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={offerDetails?.commentTwo}
              disabled
            />
          </Grid>
        </Grid>
        <Stack direction="row" spacing={1} mt={1}>
          <Button
            variant="outlined"
            onClick={() =>
              setPdfPopup({
                data: null,
                visible: false,
              })
            }
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{ whiteSpace: "nowrap" }}
            onClick={() => createExcelWithLogoAndData(offerDetails)}
          >
            Create Offer File
          </Button>
        </Stack>
      </Stack>
    </>
  );
};

export default CreateOfferPdf;
